var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"main"}},[_c('div',{ref:"viewerDom",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"viewerDom"}},[(_vm.point_marker && _vm.positions.length)?_vm._l((_vm.positions),function(item,index){return _c('div',{key:index,staticClass:"position",style:({
          left: item.x + 'px',
          top: item.y + 'px',
        })})}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }